import React from 'react';
import styles from './card-brand-header.module.css';
import iconoTarjeta from '../../assets/icono-tarjeta.png';
import visaMaster from '../../assets/visa-master.png';
import iconoOtrasTarjetas from '../../assets/icono-otras-tarjetas.png';

export const CardBrandHeader = ({ variant = 'all' }) => {
  const isAll = variant === 'all';
  const rightIcon = isAll ? visaMaster : iconoOtrasTarjetas;
  const text = isAll ? 'Pago con tarjeta' : 'Pago con otras tarjetas';

  return (
    <div className={styles.cardBrandHeader}>
      <img src={iconoTarjeta} alt="Tarjeta" className={styles.leftIcon} />
      <span className={styles.text}>{text}</span>
      <img src={rightIcon} alt={isAll ? 'Visa y Mastercard' : 'Otras tarjetas'} className={styles.rightIcon} />
    </div>
  );
};